import UserAvatar from "./icons/UserAvatar";

const BannerAvatar: React.FC<{ src?: string }> = ({ src }) => (
  <div
    className="relative flex-shrink-0 flex items-center justify-center"
    style={{ width: 220, height: 220 }}
  >
    {/* Outermost soft glow — large translucent circle */}
    <div
      className="absolute rounded-full"
      style={{
        width: 210,
        height: 210,
        background: "rgba(123, 157, 237, 0.1)",
      }}
    />

    <UserAvatar
      src={src ?? undefined}
      className="border-[8px] border-success w-[160px] h-[160px] bg-[#26295e] relative z-1"
    />
  </div>
);

export default BannerAvatar;
